import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const appShellAppBuilder = DataRouterApplicationBuilder.create('app-shell')
